import React, { useEffect, useState } from 'react';
import { Text, View, TextInput, StyleSheet, FlatList, ActivityIndicator } from 'react-native';
import { Picker } from '@react-native-picker/picker';
import db from '../../firebase';
import { collection, getDocs, query, where, orderBy, startAfter, limit } from 'firebase/firestore';
import Colors from '../../assets/Colors';
import SearchDefault from './SearchDefault';
import Product from './Product';
import NoProductFound from './NoProductFound';
import algoliasearch from 'algoliasearch/lite';

export default function Search({ params }) {

  const [productList, setProductList] = useState([]);

  const [searchText, setSearchText] = useState('');
  const [selectedGenere, setSelectedGenere] = useState('');
  const [selectedTipo, setSelectedTipo] = useState('');

  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [searchExec, setSearchExec] = useState(false);

  const itemsPerSearch = 50;

  useEffect(() => {
    setSearchText('');
    setSelectedGenere(params.homeGenere);
  }, [params.homeGenere]);

  // effettua nuova query dopo 300ms l'ultimo testo inserito, search parte dal terzo carattere
  useEffect(() => {
    if (isMinTextSearch() || selectedGenere || selectedTipo) {
      const debounceTimeout = setTimeout(() => {
        searchProduct();
      }, 350);

      return () => clearTimeout(debounceTimeout);
    } else {
      setSearchExec(false);
    }
  }, [searchText]);

  // effettua nuova query quando cambia genere o tipo
  useEffect(() => {
    searchProduct();
  }, [selectedGenere, selectedTipo]);

  function isMinTextSearch() {
    return searchText.length > 2;
  }

  async function searchProduct() {
    if (isMinTextSearch() || selectedGenere || selectedTipo) {
      setLoading(true);
      setSearchExec(true);

      if (isMinTextSearch()) {
        algoliaSearch(0);
      } else {
        firebaseSearch(false);
      }

    } else {
      setSearchExec(false);
    }
  };

  async function loadMoreData() {
    if (!loading && productList.length > 0 && currentPage >= 0) {

      if (isMinTextSearch()) {
        algoliaSearch(currentPage + 1);
      } else {
        firebaseSearch(true);
      }

    }
  };

  function setNewData(list) {
    const newList = [...productList, ...list];
    setProductList(newList);
    /*
    const trimmedList = newList.slice(-Math.min(newList.length, 100));
    setProductList(trimmedList);
    */
  }


  function algoliaSearch(pageToLoad) {
    //console.log("Algolia Search, pageToLoad->" + pageToLoad);
    try {
      //console.log('FILTRI: testo="' + searchText + '" genere="' + selectedGenere + '" tipo="' + selectedTipo + '"' + '" currentPage="' + currentPage + '"');
      const list = [];
      setCurrentPage(pageToLoad);

      const client = algoliasearch('G8QGT2JI4Z', '9b04c839402d49b6b4f7cbe6228e2c65');
      const index = client.initIndex('magazzino');

      const filt = [];
      if (selectedGenere) {
        filt.push(`genere:"${selectedGenere}"`);
      }
      if (selectedTipo) {
        filt.push(`tipologia:"${selectedTipo}"`);
      }

      index.search(searchText, {
        filters: filt.length > 0 ? filt.join(' AND ') : undefined,
        restrictSearchableAttributes: ['autore', 'titolo'],
        hitsPerPage: itemsPerSearch,
        page: pageToLoad
      }).then(({ hits }) => {

        hits.forEach((hit) => {
          const { path, lastmodified, objectID, _highlightResult, ...product } = hit;
          list.push(product);
          //console.log(product);
        });

        if (pageToLoad === 0) {
          setProductList(list);
        } else {
          if (list.length > 0) {
            setNewData(list);
          } else {
            setCurrentPage(-1);
          }
        }
        setLoading(false);

      }).catch(err => {
        console.error(err);
        setLoading(false);
      });

    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  }

  async function firebaseSearch(loadMore) {
    //console.log("Firebase Search, loadMore->" + loadMore);
    try {
      const list = [];
      const filters = [];

      if (selectedGenere) {
        filters.push(where('genere', '==', selectedGenere));
      }
      if (selectedTipo) {
        filters.push(where('tipologia', '==', selectedTipo));
      }
      filters.push(orderBy('autore'), orderBy('titolo'));
      filters.push(limit(itemsPerSearch));

      if (loadMore && productList.length > 0) {
        const lastProduct = productList[productList.length - 1];
        filters.push(startAfter(lastProduct.autore, lastProduct.titolo));
      }

      const queryRef = query(collection(db, 'magazzino'), ...filters);
      const querySnap = await getDocs(queryRef);

      querySnap.forEach((doc) => {
        list.push(doc.data());
      });

      if (loadMore == false) {
        setProductList(list);
        setCurrentPage(0);
      } else {
        if (list.length > 0) {
          setNewData(list);
        } else {
          setCurrentPage(-1);
        }
      }
      setLoading(false);

    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  }

  return (
    <>
      <TextInput
        style={styles.searchInput}
        placeholder="Ricerca per Titolo o Artista"
        value={searchText}
        onChangeText={setSearchText}
        placeholderTextColor="#999"
        aria-label="Ricerca per Titolo o Artista"
      />

      <View style={styles.pickerRow}>
        <View style={styles.pickerContainer}>
          <Picker
            selectedValue={selectedGenere}
            onValueChange={(itemValue) => setSelectedGenere(itemValue)}
            style={styles.picker} aria-label="Seleziona un genere musicale" >
            <Picker.Item label="Genere musicale" value="" style={styles.pickerItem} />
            {window.appData.generiMusicali.map((g, index) => (
              <Picker.Item key={index} label={g} value={g} style={styles.pickerItem} />
            ))}
          </Picker>
        </View>
        <View style={{ width: 8 }} />
        <View style={styles.pickerContainer}>
          <Picker
            selectedValue={selectedTipo}
            onValueChange={(itemValue) => setSelectedTipo(itemValue)}
            style={styles.picker} aria-label="Seleziona il tipo di prodotto" >
            <Picker.Item label="Tipo prodotto" value="" style={styles.pickerItem} />
            {window.appData.tipoProdotto.map((t, index) => (
              <Picker.Item key={index} label={t} value={t} style={styles.pickerItem} />
            ))}
          </Picker>
        </View>
      </View>

      {searchExec ? (
        <View style={{ flex: 1, paddingTop: 10 }}>
          <FlatList
            data={productList}
            renderItem={({ item }) => <Product p={item} contacts={{ email: params.contattoEmail, telefono: params.contattoTelefono }} />}
            keyExtractor={(item, index) => index.toString()}
            ListEmptyComponent={loading ? null : <NoProductFound />}
            onEndReachedThreshold={0.5}
            onEndReached={loadMoreData}
            keyboardDismissMode="on-drag"
            ListFooterComponent={loading && <ActivityIndicator style={{ marginVertical: 20 }} />}
          />
        </View>
      ) : (
        <View style={{ flexDirection: 'row', paddingTop: 10 }}>
          <SearchDefault />
        </View>
      )}
    </>
  );
}

const styles = StyleSheet.create({
  searchInput: {
    height: 40,
    borderRadius: 15,
    backgroundColor: '#f0f0f0',
    paddingHorizontal: 20,
    marginBottom: 10,
    borderColor: '#ccc',
    borderWidth: 1,
  },
  pickerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  pickerContainer: {
    flex: 1,
  },
  picker: {
    height: 40,
    borderRadius: 15,
    paddingHorizontal: 20,
    backgroundColor: '#f0f0f0',
    borderColor: '#ccc',
    borderWidth: 1,
  },
  pickerItem: {
    fontSize: 14,
  },
});
